import React, { ReactElement } from 'react';
import FormService from '../../services/form-service';

const Form: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const AUTOCOMPLETE_ON: string = 'on';

  const {
    withAutocomplete,
    id,
    className,
    onSubmit,
    onChange,
    children,
  } = props;

  return (
    <form
      id={id}
      className={className}
      onSubmit={onSubmit || FormService.onSubmitFormEmptyAction}
      onChange={onChange}
      {
        ...(withAutocomplete ? {
          autoComplete: AUTOCOMPLETE_ON,
        } : {})
      }
    >
      {children}
    </form>
  );
});

export default Form;
